import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'app/App Store/state';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';
export interface DynamicDetailData {
  id: number;
  key: string;
  value: string;
}
@Component({
  selector: 'app-student-placement-reports',
  templateUrl: './student-placement-reports.component.html',
  styleUrls: ['./student-placement-reports.component.scss',"../../../../../../assets/sass/libs/datatables.scss",],
  encapsulation: ViewEncapsulation.None,
})
export class StudentPlacementReportsComponent implements OnInit {

  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue=''
  isFilter:boolean=false
  // column header
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Email", prop: "email" },
    { name: "Phone", prop: "phone" },
    { name: "Actions", prop: "actions" },
  ];

  // private
  imageUrl=environment.apiUrls.imageUrl;
  user_role:any
  activeTab:any

  guideline_data:any
  row_data:any
  @ViewChild('dynamicContainer', { read: ViewContainerRef, static: false }) dynamicContainer: ViewContainerRef;

  
  constructor(public apiService:ApiService,
              public toastr: ToastrService,private modalService: NgbModal,
              private session:SessionStorageService,private route: Router,
              private resolver: ComponentFactoryResolver ) { 

              let setting_data = JSON.parse(localStorage.getItem('setting-record'))
              this.guideline_data = setting_data.filter((item) => item.key == 'Placements Report') 

                
            }

  ngOnInit(): void {
    this.activeReportsTab('Placement')

  }
 
  activeReportsTab(data){
    if(data == 'Performer'){
      this.activeTab=data
      this.getStudentReportsList()
    }
    else{
      if(data == 'Placement'){
        this.activeTab=data
        this.getStudentPlaceReportsList()
      }
    }
  }

  getStudentReportsList(){
   this.apiService.getStudentsReports(this.page.pageNumber+1,this.limitRef).subscribe((res:any)=>{
    this.rows=res.items
    this.page.totalPages=res.total
   })
  }
  getStudentPlaceReportsList(){
    this.apiService.getStudentsPlacementReports(this.page.pageNumber+1,this.limitRef).subscribe((res:any)=>{
     this.rows=res.items
     this.page.totalPages=res.total
    })
   }
   updateStudent(id){
    let body={
      placement_business:'all'
    }
   if(id){
    this.apiService.updateStudent(id,body).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.toastr.success('Delete successfully')
        this.getStudentPlaceReportsList()
      }
      else{
        this.toastr.error(res.error)
      }
    })
   }
   }
   isValidLinkedIn(linkedin: string): boolean {
    const pattern = /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(in|pub|company|groups)\/[\w\/?=.-]+$/;
    return pattern.test(linkedin);
  }

  createDynamicComponent(data:DynamicDetailData) {
    this.row_data =data
    // Create a factory for the dynamic component
    const factory = this.resolver.resolveComponentFactory(DynamicDetailComponent);

    // Create an instance of the dynamic component
    const componentRef = factory.create(this.dynamicContainer.injector);

    // Set the data for the dynamic component
    componentRef.instance.data = data;

    // Insert the dynamic component into the view container
    this.dynamicContainer.insert(componentRef.hostView);
  }

}
